/**
 * The admin screens' frame (PRD-591, PRD-625): the same theme and query client as the app, none of its sign-in.
 * Admin sits behind Identity-Aware Proxy, so the browser arrives already identified (the IAP cookie rides every
 * admin call, src/api/admin.ts): there is no Firebase gate here and no stream. The screens are the cockpit's
 * routes from the ONE route tree (routeTree.tsx), built for the admin entry, which refuses the main app's paths.
 */
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { queryClient } from '../api';
import { ThemeProvider } from '../theme';
import { ModeToggle, Viewport } from './chrome';
import { buildRouter } from './routeTree';

const router = buildRouter('admin');

export function AdminApp() {
  return (
    <ThemeProvider>
      <Viewport>
        <ModeToggle />
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={router} />
        </QueryClientProvider>
      </Viewport>
    </ThemeProvider>
  );
}
